module.exports = __webpack_public_path__ + "static/media/rebirth_30.bb728bdb.jpg";